export default "__VITE_ASSET__CpHlR0oi__"